export function getBaseFormulaName(name) {
  return name.replace(/\s*\(\d+\.?\d*\s*(?:kg|g)\)\s*$/, '').trim()
}

export function getWeightVariants(product, allProducts) {
  const base = getBaseFormulaName(product.name)
  return allProducts
    .filter(p => getBaseFormulaName(p.name) === base)
    .sort((a, b) => a.weight - b.weight)
}

export function groupByFormula(products) {
  const map = {}
  for (const p of products) {
    const base = getBaseFormulaName(p.name)
    if (!map[base]) {
      map[base] = { baseName: base, variants: [] }
    }
    map[base].variants.push(p)
  }
  return Object.values(map)
}
